export const PATIENT_CASE_INCOMPLETE_INTAKE_NOTICES = [
  "Message captured before the call disconnected; intake may be incomplete.",
  "Final readback was not confirmed.",
] as const;

export const PATIENT_CASE_FALLBACK_CALLBACK_PREFIX = "Fallback callback number";

export enum PatientCaseType {
  PATIENT_MESSAGE = "patient_message",
  PRESCRIPTION_REFILL = "prescription_refill",
  SCHEDULING_FOLLOW_UP = "scheduling_follow_up",
  SELF_PAY_FOLLOWUP = "self_pay_followup",
  INSURANCE_VERIFICATION_FOLLOWUP = "insurance_verification_followup",
}

export enum PatientCaseDeliveryStatus {
  PENDING = "pending",
  SENT = "sent",
  FAILED = "failed",
  UNKNOWN = "unknown",
}

export enum PatientCaseProviderRoutingStrategy {
  FIXED = "fixed",
  ORDERED_SOURCES = "ordered_sources",
  PREVIOUS_CASE_THEN_PRIMARY = "previous_case_then_primary",
}

export enum PatientCaseAppointmentReadFailurePolicy {
  REJECT = "reject",
  SKIP_APPOINTMENT_TIERS = "skip_appointment_tiers",
}

export enum PatientCaseUpcomingAmbiguityPolicy {
  REJECT = "reject",
  SKIP_TIER = "skip_tier",
}

export enum PatientCaseProviderResolutionSource {
  APPOINTMENT_HISTORY = "appointment_history",
  FALLBACK = "fallback",
  FIXED = "fixed",
  PRESCRIPTION = "prescription",
  PREVIOUS_REFILL = "previous_refill",
  PRIMARY_PROVIDER = "primary_provider",
  UPCOMING_APPOINTMENT = "upcoming_appointment",
}

export enum PatientCaseErrorCode {
  PROVIDER_UNAVAILABLE = "patient_case_provider_unavailable",
  UPCOMING_APPOINTMENT = "patient_case_upcoming_appointment",
}
